import styled, { css } from 'styled-components';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
import { getFont } from '@finect/tabular-utils/getFont';
var smallStyles = css(["width:22px;height:22px;line-height:20px;"]);
var checkedStyles = css(["border:1px solid ", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.linkColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mainColor;
});
export var Step = styled.div.withConfig({
  displayName: "Facts__Step",
  componentId: "sc-rof1v6-0"
})(["border-radius:4px;cursor:default;font-size:12px;color:", ";text-align:center;", " ", " ", ""], function (_ref3) {
  var theme = _ref3.theme,
    light = _ref3.light;
  return light ? theme.colors.fontL : 'currentColor';
}, function (_ref4) {
  var small = _ref4.small;
  return small && smallStyles;
}, function (_ref5) {
  var _ref5$disabled = _ref5.disabled,
    disabled = _ref5$disabled === void 0 ? false : _ref5$disabled;
  return disabled && 'background-color: rgba(0, 0, 0, 0.4);';
}, function (_ref6) {
  var checked = _ref6.checked;
  return checked && checkedStyles;
});
export var Facts = styled.div.withConfig({
  displayName: "Facts",
  componentId: "sc-rof1v6-1"
})(["display:flex;flex-wrap:wrap;margin-top:auto;"]);
export var Fact = styled.div.withConfig({
  displayName: "Facts__Fact",
  componentId: "sc-rof1v6-2"
})(["width:50%;", ""], function (_ref7) {
  var _ref7$bottomMargin = _ref7.bottomMargin,
    bottomMargin = _ref7$bottomMargin === void 0 ? false : _ref7$bottomMargin;
  return bottomMargin && 'margin-bottom: 18px;';
});
export var FactHeader = styled.div.withConfig({
  displayName: "Facts__FactHeader",
  componentId: "sc-rof1v6-3"
})(["color:", ";", ";", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.uiD;
}, textEllipsis, getFont('-2', 'compact'));
export var FactValue = styled.div.withConfig({
  displayName: "Facts__FactValue",
  componentId: "sc-rof1v6-4"
})(["color:", ";", ""], function (_ref9) {
  var theme = _ref9.theme,
    light = _ref9.light;
  return light ? theme.colors.uiD : theme.colors.terciary;
}, textEllipsis);